export default __webpack_public_path__ + "c17a1a07bf95e7014b11c4f555dd58aa.png";